(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/fractiongames/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/lotto/components/fractiongames/assets/javascripts/prescript.js');

'use strict';

svs.lotto = svs.lotto || {};
svs.lotto.components = svs.lotto.components || {};
svs.lotto.components.fractiongames = svs.lotto.components.fractiongames || {};

 })(window);